<div class="grid" style="margin-top: 8px;">
  <div class="col-12 lg:col-6 flex flex-column">
    <div class="card">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.overview.assetInfo' | transloco}}</h4></div>
      <hr>
      <div class="hidden xl:flex">
        <table class="details-table striped-table" *ngIf="asset">
          <tr>
            <td class="p-3 bold">{{'attribute.uuid' | transloco}}</td>
            <td class="pr-1"><app-clipboard-label [value]="asset.uuid" [copiedValue]="asset.uuid"></app-clipboard-label></td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'model.tenant' | transloco}}</td>
            <td>{{asset.tenant?.name}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'attribute.latitude' | transloco}}</td>
            <td>{{asset.latitude | number:'.6'}}</td>
          </tr>
<!--          <tr>-->
<!--            <td class="p-3 bold">{{'attribute.creationDate' | transloco}}</td>-->
<!--            <td>{{asset.latitude}}</td>-->
<!--          </tr>-->
        </table>
        <app-table-skeleton *ngIf="!asset"
                            class="w-full"
                            [rows]="3"
                            height="200px"
                            [striped]="true"
        ></app-table-skeleton>
        <p-divider layout="vertical"></p-divider>
        <table class="details-table striped-table" *ngIf="asset">
          <tr>
            <td class="p-3 bold">{{'model.representation' | transloco}}</td>
            <td>{{asset.assetRepresentation?.name}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'attribute.timezone' | transloco}}</td>
            <td>{{asset.timezone}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'attribute.longitude' | transloco}}</td>
            <td>{{asset.longitude | number:'.6'}}</td>
          </tr>
        </table>
        <app-table-skeleton *ngIf="!asset"
                            class="w-full"
                            [rows]="3"
                            [striped]="true"
        ></app-table-skeleton>
      </div>
      <div class="block xl:hidden">
        <table class="details-table striped-table" *ngIf="asset">
          <tr>
            <td class="p-3 bold">{{'attribute.uuid' | transloco}}</td>
            <td><app-clipboard-label [value]="asset.uuid" [copiedValue]="asset.uuid"></app-clipboard-label></td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'model.tenant' | transloco}}</td>
            <td>{{asset.tenant?.name}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'attribute.latitude' | transloco}}</td>
            <td>{{asset.latitude | number:'.6'}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'model.representation' | transloco}}</td>
            <td>{{asset.assetRepresentation?.name}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'attribute.timezone' | transloco}}</td>
            <td>{{asset.timezone}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'attribute.longitude' | transloco}}</td>
            <td>{{asset.longitude | number:'.6'}}</td>
          </tr>
        </table>
        <app-table-skeleton *ngIf="!asset"
                            class="w-full"
                            [rows]="3"
                            height="200px"
                            [striped]="true"
        ></app-table-skeleton>
      </div>
    </div>
    <div class="card">
      <div class="card-header pt-1"><h4 class="mb-1">{{'model.sensors' | transloco}}</h4></div>
      <hr>
      <app-generic-graph
        dataType="linear"
        chartType="bar"
        [height]="250"
        [categories]="activeDataCategories"
        [customSeries]="true"
        [tooltipShared]="true"
        [legend]="true"
        [data]="activeData"
        *ngIf="!noMeasurements && !loadingMeasurements"
      ></app-generic-graph>
      <app-table-skeleton *ngIf="loadingMeasurements"
                          class="w-full"
                          [rows]="6"
      ></app-table-skeleton>
      <div
        *ngIf="noMeasurements && !loadingMeasurements"
        [style.height]="'250px'"
        class="flex flex-1 justify-content-center align-items-center"
      >
        <p class="text-xl font-italic">{{'empty.sensors' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-6">
    <div class="card">
      <div class="card-header pt-1">
        <h4 class="mb-1">{{'attribute.location' | transloco}}</h4>
      </div>
      <hr>
      <div *ngIf="!loadedMap">
        <app-table-skeleton class="w-full"
                            [rows]="13"
                            height="550px"
        ></app-table-skeleton>
      </div>
      <div id="map" class="rounded"
           [style.display]="!loadedMap ? 'none' : 'block'"></div>
    </div>
  </div>
</div>
<div class="grid" style="margin-top: 2px;">
  <div class="col-12">
    <div class="card">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.overview.properties' | transloco}}</h4></div>
      <hr>
      <div
        *ngFor="let property of properties"
        class="flex flex-column sm:flex-row"
        style="border-bottom: 1px solid #DEE2E6;"
      >
        <div class="p-3 flex-1 bold" >{{property.name}}</div>
        <div class="p-3 flex-1 sm:text-right">{{property.value}}</div>
      </div>
      <div
        *ngIf="properties && properties.length == 0"
        [style.height]="'320px'"
        class="flex flex-1 justify-content-center align-items-center"
      >
        <p class="text-xl font-italic">{{'empty.properties' | transloco}}</p>
      </div>
      <app-table-skeleton *ngIf="!properties"
                          class="w-full"
                          [rows]="8"
      ></app-table-skeleton>
    </div>
  </div>
</div>
